// extracted by mini-css-extract-plugin
module.exports = {"table":"ChildCautionSection_table__m2lms","head":"ChildCautionSection_head__nJFWR","row":"ChildCautionSection_row__bv4Or"};